var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import Content from './content.vue';
let default_1 = class extends Vue {
    constructor() {
        super(...arguments);
        this.keepAlive = false;
        this.keepAliveProps = {
        // include: [
        // ],
        // exclude: [
        // ],
        };
    }
    get contentClass() {
        const classList = ['app-layout-content', 'app-layout-childrenpage'];
        //如果是iframe嵌套页面添加边距
        if (this.AppConfig.ChildrenPage) {
            classList.push('app-layout-padding');
        }
        return classList.join(' ');
    }
    mounted() { }
    updated() { }
    destroyed() { }
};
default_1 = __decorate([
    Component({
        components: { Content },
    })
], default_1);
export default default_1;
